import * as categories from '@/utils/categories'
import * as inventoryCategories from '@/utils/inventoryCategories'

export default {
  products: [],
  loading: false,
  product: {},
  categories,
  inventoryCategories,
  total: 0,
  FilteredCount: 0,

  // Category List
  'product-categories': [],
  'category-loading': false,
  'category-total': 0,
  'category-FilteredCount': 0,

  'product-historical': [],
  'product-loading': false,
  'product-total': 0,
  'product-FilteredCount': 0
}
